import axios from 'axios'
import { baseURL } from './../../env.js'

// export const baseURL = '/'

const api = axios.create({
    baseURL
})

api.interceptors.request.use(async config => {

  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['X-Token'] = `Bearer ${token}`;
  }
  // config.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  // config.headers.post['Accept'] ='application/json';
  // config.headers.post['Content-Type'] ='application/json';
  // config.headers.post['Access-Control-Allow-Origin'] = '*';

  return config;
})

export default api
